// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.prf-page {
  min-height: calc(100vh - 80px);
  background: #f0f4f8;
  padding: 40px 20px 60px;
}

.prf-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  max-width: 1000px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .prf-layout {
    grid-template-columns: 1fr;
  }
}

.prf-sidebar {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.prf-main {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.prf-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 24px;
}
.prf-card--identity {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.prf-avatar {
  width: 92px;
  height: 92px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  border: 3px solid #12b7ad;
  box-shadow: 0 8px 24px rgba(18, 183, 173, 0.22);
  margin-bottom: 6px;
}

.prf-name {
  font-size: 1.3rem;
  font-weight: 800;
  color: #0f172a;
  margin: 4px 0 0;
  line-height: 1.25;
}

.prf-email {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 0.8rem;
  color: #94a3b8;
  margin: 0 0 8px;
}

.prf-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}
.prf-detail-row:last-of-type {
  border-bottom: none;
}

.prf-detail-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  color: #94a3b8;
  white-space: nowrap;
}

.prf-detail-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
  text-align: right;
}

.prf-empty {
  color: #c0cfe0;
  font-style: italic;
  font-weight: 400;
}

.prf-input {
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.9rem;
  color: #0f172a;
  width: 100%;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.prf-input:focus {
  border-color: #12b7ad;
  box-shadow: 0 0 0 3px rgba(18, 183, 173, 0.12);
}
.prf-input--name {
  text-align: center;
  font-size: 1.1rem;
  font-weight: 700;
}

.prf-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  padding: 9px 18px;
  transition: all 0.2s;
  border: none;
}
.prf-btn--primary {
  background: #12b7ad;
  color: #fff;
}
.prf-btn--primary:hover:not(:disabled) {
  background: #0e928a;
}
.prf-btn--primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.prf-btn--outline {
  background: transparent;
  border: 1.5px solid #12b7ad;
  color: #12b7ad;
}
.prf-btn--outline:hover {
  background: #12b7ad;
  color: #fff;
}
.prf-btn--ghost {
  background: transparent;
  border: 1.5px solid #e2e8f0;
  color: #64748b;
}
.prf-btn--ghost:hover {
  border-color: #adb5bd;
  color: #333;
}
.prf-btn--ghost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.prf-btn--full {
  width: 100%;
  margin-top: 4px;
}
.prf-btn--sm {
  padding: 6px 14px;
  font-size: 0.8rem;
}

.prf-edit-actions {
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 4px;
}
.prf-edit-actions .prf-btn {
  flex: 1 1;
}

.prf-stats {
  display: flex;
  align-items: stretch;
  padding: 16px 20px;
  gap: 0;
}

.prf-stat {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.prf-stat__num {
  font-size: 1.5rem;
  font-weight: 800;
  color: #12b7ad;
  line-height: 1;
}
.prf-stat__lbl {
  font-size: 0.7rem;
  color: #94a3b8;
  text-align: center;
  line-height: 1.3;
}

.prf-stat-divider {
  width: 1px;
  background: #f1f5f9;
  margin: 4px 0;
}

.prf-section-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 7px;
}

.prf-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.prf-completion__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
}
.prf-completion__sub {
  font-size: 0.8rem;
  color: #94a3b8;
  margin: 3px 0 0;
}
.prf-completion__pct {
  font-size: 1.6rem;
  font-weight: 800;
  color: #12b7ad;
  line-height: 1;
  flex-shrink: 0;
}

.prf-progress-track {
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 99px;
  overflow: hidden;
  margin-bottom: 16px;
}

.prf-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #12b7ad, #17e5d9);
  border-radius: 99px;
  transition: width 0.6s ease;
}

.prf-checklist {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.prf-checklist__item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
  color: #94a3b8;
}
.prf-checklist__item--done {
  color: #1e293b;
}
.prf-checklist__item--done .prf-checklist__dot {
  background: #12b7ad;
  box-shadow: 0 0 0 3px rgba(18, 183, 173, 0.18);
}
.prf-checklist__item--done .prf-checklist__dot::after {
  content: "✓";
  color: #fff;
  font-size: 0.55rem;
  font-weight: 800;
}
.prf-checklist__dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #e2e8f0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prf-iv-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.prf-iv-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid #f1f5f9;
}
.prf-iv-item:last-child {
  border-bottom: none;
}
.prf-iv-item__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f0fffe;
  color: #12b7ad;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.prf-iv-item__body {
  flex: 1 1;
  min-width: 0;
}
.prf-iv-item__job {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prf-iv-item__date {
  font-size: 0.75rem;
  color: #94a3b8;
  margin: 0;
}
.prf-iv-item__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}
.prf-iv-item__score {
  font-size: 0.78rem;
  font-weight: 700;
  color: #64748b;
}

.prf-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 99px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.prf-badge--strong {
  background: #d1fae5;
  color: #065f46;
}
.prf-badge--average {
  background: #fef9c3;
  color: #854d0e;
}
.prf-badge--weak {
  background: #fee2e2;
  color: #991b1b;
}
.prf-badge--pending {
  background: #dbeafe;
  color: #1e40af;
}
.prf-badge--done {
  background: #f1f5f9;
  color: #475569;
}

.prf-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: none;
  border: none;
  color: #12b7ad;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s;
}
.prf-link:hover {
  opacity: 0.75;
}
.prf-link--sm {
  font-size: 0.75rem;
}

.prf-skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
}

.prf-skeleton-row {
  height: 52px;
  border-radius: 10px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e8eef4 50%, #f1f5f9 75%);
  background-size: 400% 100%;
  animation: prf-shimmer 1.4s ease infinite;
}

@keyframes prf-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
.prf-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 32px 0;
  color: #c0cfe0;
}
.prf-empty-state p {
  margin: 0;
  font-size: 0.88rem;
}

.prf-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: prf-spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes prf-spin {
  to {
    transform: rotate(360deg);
  }
}
.prf-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  animation: prf-slide-in 0.3s ease;
}
.prf-toast--success {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}
.prf-toast--error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

@keyframes prf-slide-in {
  from {
    top: 8px;
    opacity: 0;
  }
  to {
    top: 24px;
    opacity: 1;
  }
}
.profile-page {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 60px 16px 40px;
  background: #f5f7fa;
}

.profile-card {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.profile-card__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 24px 24px;
  text-align: center;
}
.profile-card__name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 12px 0 4px;
}
.profile-card__email {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 16px;
}
.profile-card__info {
  padding: 0 24px 24px;
}
.profile-card__actions {
  display: flex;
  gap: 12px;
  padding: 0 24px 24px;
  justify-content: flex-end;
}
@media (max-width: 480px) {
  .profile-card__actions {
    flex-direction: column-reverse;
  }
}

.profile-divider {
  margin: 0 24px;
  border-color: #f0f0f0;
}

.profile-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #12b7ad, #0d8981);
  color: #fff;
  font-size: 1.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.profile-info-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #f5f5f5;
}
.profile-info-row:last-child {
  border-bottom: none;
}

.profile-info-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8125rem;
  color: #6c757d;
  width: 110px;
  flex-shrink: 0;
}

.profile-info-value {
  font-size: 0.9375rem;
  color: #222;
  font-weight: 500;
}

.profile-input {
  flex: 1 1;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.9375rem;
  outline: none;
  transition: border-color 0.2s;
  color: #1a1a2e;
}
.profile-input:focus {
  border-color: #12b7ad;
  box-shadow: 0 0 0 3px rgba(18, 183, 173, 0.12);
}
.profile-input--name {
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 10px 0 4px;
  max-width: 320px;
  flex: none;
  width: 100%;
}

.profile-btn-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  border: 1.5px solid #12b7ad;
  color: #12b7ad;
  background: transparent;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.profile-btn-edit:hover {
  background: #12b7ad;
  color: #fff;
}

.profile-btn-save {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 24px;
  background: #12b7ad;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.profile-btn-save:hover:not(:disabled) {
  background: #0e928a;
}
.profile-btn-save:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
@media (max-width: 480px) {
  .profile-btn-save {
    width: 100%;
    justify-content: center;
  }
}

.profile-btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  background: transparent;
  border: 1.5px solid #dee2e6;
  color: #6c757d;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.profile-btn-cancel:hover:not(:disabled) {
  border-color: #adb5bd;
  color: #333;
}
.profile-btn-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 480px) {
  .profile-btn-cancel {
    width: 100%;
    justify-content: center;
  }
}

.profile-last-updated {
  text-align: center;
  font-size: 0.75rem;
  color: #adb5bd;
  padding: 0 24px 20px;
  margin: 0;
}

.profile-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: profile-spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes profile-spin {
  to {
    transform: rotate(360deg);
  }
}
.profile-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  animation: profile-slide-down 0.3s ease;
  white-space: nowrap;
}
.profile-toast--success {
  background: #d1f2eb;
  color: #1a7a5e;
  border: 1px solid #a3e4d7;
}
.profile-toast--error {
  background: #fdecea;
  color: #c0392b;
  border: 1px solid #f5c6cb;
}

@keyframes profile-slide-down {
  from {
    top: 8px;
    opacity: 0;
  }
  to {
    top: 24px;
    opacity: 1;
  }
}
.prf-candidate {
  display: grid;
  gap: 18px;
}

.prf-candidate__subtitle,
.prf-candidate__muted {
  margin: 5px 0 0;
  color: #6b7f92;
  font-size: 13px;
}

.prf-candidate__loading,
.prf-candidate__empty {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #5d7185;
}

.prf-candidate__notice {
  padding: 11px 13px;
  border-radius: 8px;
  font-size: 13px;
}

.prf-candidate__notice--success {
  color: #08745f;
  background: #e9f9f3;
}

.prf-candidate__notice--error {
  color: #a63232;
  background: #fff0f0;
}

.prf-candidate__summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.prf-candidate__summary-item {
  min-width: 0;
  padding: 12px;
  border: 1px solid #e3ebf2;
  border-radius: 8px;
  background: #fbfdff;
}
.prf-candidate__summary-item span,
.prf-candidate__summary-item strong {
  display: block;
}
.prf-candidate__summary-item span {
  margin-bottom: 4px;
  color: #718397;
  font-size: 11px;
  text-transform: uppercase;
}
.prf-candidate__summary-item strong {
  color: #17324d;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.prf-candidate__description span {
  color: #718397;
  font-size: 12px;
}
.prf-candidate__description p {
  margin: 6px 0 0;
  color: #314b63;
  line-height: 1.65;
}

.prf-candidate__form,
.prf-candidate__subsection {
  display: grid;
  gap: 16px;
}

.prf-candidate__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.prf-candidate__form label {
  display: grid;
  gap: 6px;
  min-width: 0;
}
.prf-candidate__form label > span {
  color: #28445f;
  font-size: 12px;
  font-weight: 700;
}
.prf-candidate__form label input,
.prf-candidate__form label select,
.prf-candidate__form label textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid #d8e3ed;
  border-radius: 8px;
  padding: 10px 11px;
  color: #17324d;
  background: #fff;
  outline: none;
}
.prf-candidate__form label input:focus,
.prf-candidate__form label select:focus,
.prf-candidate__form label textarea:focus {
  border-color: #16aaa1;
  box-shadow: 0 0 0 3px rgba(22, 170, 161, 0.12);
}
.prf-candidate__form label input[readonly],
.prf-candidate__form label select[readonly],
.prf-candidate__form label textarea[readonly] {
  color: #6e8193;
  background: #f3f6f9;
}

.prf-candidate__wide-field {
  grid-column: 1/-1;
}

.prf-candidate__subsection {
  padding-top: 16px;
  border-top: 1px solid #e6edf3;
}
.prf-candidate__subsection h4 {
  margin: 0;
  color: #17324d;
  font-size: 15px;
}

.prf-candidate__subsection-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.prf-candidate__history {
  display: grid;
  gap: 13px;
  padding: 14px;
  border: 1px solid #e0e8ef;
  border-radius: 8px;
  background: #fbfdff;
}

.prf-candidate__remove {
  justify-self: start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  color: #b43b3b;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
}

.prf-candidate__documents {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  padding-top: 16px;
  border-top: 1px solid #e6edf3;
}
.prf-candidate__documents h4 {
  margin: 0 0 10px;
  color: #17324d;
  font-size: 14px;
}
.prf-candidate__documents .image-uploader-container {
  min-height: 190px;
}

.prf-candidate__actions {
  justify-content: flex-end;
  padding-top: 4px;
}

@media (max-width: 820px) {
  .prf-candidate__summary,
  .prf-candidate__grid,
  .prf-candidate__documents {
    grid-template-columns: 1fr;
  }
  .prf-candidate .prf-section-head {
    align-items: flex-start;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/profile.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,8BAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAKA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAFF;AAIE;EAPF;IAQI,0BAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAKA;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;AAFF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAFJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,+CAAA;EACA,kBAAA;AAJF;;AAQA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AALF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AANF;AAQE;EAAiB,mBAAA;AALnB;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AALF;;AAQA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AALF;;AAQA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AASA;EACE,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,8CAAA;AANF;AAQE;EACE,qBChIU;EDiIV,8CAAA;AANJ;AASE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAPJ;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;AATF;AAWE;EACE,mBC1JU;ED2JV,WAAA;AATJ;AAUI;EAAyB,mBAAA;AAP7B;AAQI;EAAa,YAAA;EAAc,mBAAA;AAJ/B;AAOE;EACE,uBAAA;EACA,2BAAA;EACA,cCnKU;AD8Jd;AAMI;EAAU,mBCpKA;EDoK0B,WAAA;AAFxC;AAKE;EACE,uBAAA;EACA,2BAAA;EACA,cAAA;AAHJ;AAII;EAAU,qBAAA;EAAuB,WAAA;AAArC;AACI;EAAa,YAAA;EAAc,mBAAA;AAG/B;AAAE;EAAU,WAAA;EAAa,eAAA;AAIzB;AAFE;EAAQ,iBAAA;EAAmB,iBAAA;AAM7B;;AAHA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAMF;AAJE;EAAW,SAAA;AAOb;;AAHA;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;AAMF;;AAHA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAMF;AAJE;EACE,iBAAA;EACA,gBAAA;EACA,cC/MU;EDgNV,cAAA;AAMJ;AAHE;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAKJ;;AADA;EACE,UAAA;EACA,mBAAA;EACA,aAAA;AAIF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAGF;;AAEE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAEE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAAJ;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cCrQU;EDsQV,cAAA;EACA,cAAA;AADJ;;AAKA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,YAAA;EACA,oDAAA;EACA,mBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AAFJ;AAII;EACE,cAAA;AAFN;AAGM;EACE,mBC7SM;ED8SN,8CAAA;AADR;AAEQ;EAAW,YAAA;EAAc,WAAA;EAAa,kBAAA;EAAoB,gBAAA;AAIlE;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAIA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AADF;AAGE;EAAe,mBAAA;AAAjB;AAEE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cCxVU;EDyVV,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAAJ;AAGE;EACE,SAAA;EACA,YAAA;AADJ;AAIE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;AAJJ;AAOE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AALJ;;AAUA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAPF;AASE;EAAa,mBAAA;EAAqB,cAAA;AALpC;AAME;EAAa,mBAAA;EAAqB,cAAA;AAFpC;AAGE;EAAa,mBAAA;EAAqB,cAAA;AACpC;AAAE;EAAa,mBAAA;EAAqB,cAAA;AAIpC;AAHE;EAAa,mBAAA;EAAqB,cAAA;AAOpC;;AAHA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,cC1ZY;ED2ZZ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;AAMF;AAJE;EAAU,aAAA;AAOZ;AALE;EAAQ,kBAAA;AAQV;;AAJA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AAOF;;AAJA;EACE,YAAA;EACA,mBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;AAOF;;AAJA;EACE;IAAO,2BAAA;EAQP;EAPA;IAAO,4BAAA;EAUP;AACF;AAPA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AASF;AAPE;EAAI,SAAA;EAAW,kBAAA;AAWjB;;AAPA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,qBAAA;AAUF;;AAPA;EAAsB;IAAK,yBAAA;EAYzB;AACF;AAVA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,iCAAA;AAYF;AAVE;EAAa,mBAAA;EAAqB,cAAA;EAAgB,yBAAA;AAepD;AAdE;EAAa,mBAAA;EAAqB,cAAA;EAAgB,yBAAA;AAmBpD;;AAhBA;EACE;IAAO,QAAA;IAAU,UAAA;EAqBjB;EApBA;IAAO,SAAA;IAAW,UAAA;EAwBlB;AACF;AArBA;EACE,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AAuBF;;AApBA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AAuBF;AArBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAuBJ;AApBE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAsBJ;AAnBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAqBJ;AAlBE;EACE,oBAAA;AAoBJ;AAjBE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,yBAAA;AAmBJ;AAjBI;EANF;IAOI,8BAAA;EAoBJ;AACF;;AAhBA;EACE,cAAA;EACA,qBAAA;AAmBF;;AAhBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AAmBF;AAjBE;EACE,mBAAA;AAmBJ;;AAfA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAkBF;;AAfA;EACE,oBAAA;EACA,WAAA;EACA,gBAAA;AAkBF;;AAfA;EACE,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;AAkBF;AAhBE;EACE,qBChmBU;EDimBV,8CAAA;AAkBJ;AAfE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AAiBJ;;AAbA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,2BAAA;EACA,cCrnBY;EDsnBZ,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAgBF;AAdE;EACE,mBC9nBU;ED+nBV,WAAA;AAgBJ;;AAZA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBCxoBY;EDyoBZ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAeF;AAbE;EACE,mBAAA;AAeJ;AAZE;EACE,aAAA;EACA,mBAAA;AAcJ;AAXE;EAvBF;IAwBI,WAAA;IACA,uBAAA;EAcF;AACF;;AAXA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAcF;AAZE;EACE,qBAAA;EACA,WAAA;AAcJ;AAXE;EACE,YAAA;EACA,mBAAA;AAaJ;AAVE;EAxBF;IAyBI,WAAA;IACA,uBAAA;EAaF;AACF;;AAVA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;AAaF;;AAVA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,4CAAA;EACA,qBAAA;AAaF;;AAVA;EACE;IACE,yBAAA;EAaF;AACF;AAVA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,uCAAA;EACA,mBAAA;AAYF;AAVE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAYJ;AATE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAWJ;;AAPA;EACE;IACE,QAAA;IACA,UAAA;EAUF;EARA;IACE,SAAA;IACA,UAAA;EAUF;AACF;AAPA;EACE,aAAA;EACA,SAAA;AASF;;AANA;;EAEE,eAAA;EACA,cAAA;EACA,eAAA;AASF;;AANA;;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AASF;;AANA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AASF;;AANA;EACE,cAAA;EACA,mBAAA;AASF;;AANA;EACE,cAAA;EACA,mBAAA;AASF;;AANA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AASF;;AANA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AASF;AAPE;;EAEE,cAAA;AASJ;AANE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAQJ;AALE;EACE,cAAA;EACA,eAAA;EACA,uBAAA;AAOJ;;AAFE;EACE,cAAA;EACA,eAAA;AAKJ;AAFE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAIJ;;AAAA;;EAEE,aAAA;EACA,SAAA;AAGF;;AAAA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAGF;;AAAA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAGF;AADE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAGJ;AAAE;;;EAGE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAEJ;AAAI;;;EACE,qBAAA;EACA,8CAAA;AAIN;AADI;;;EACE,cAAA;EACA,mBAAA;AAKN;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACE,iBAAA;EACA,6BAAA;AAGF;AADE;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAGJ;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAEF;AAAE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAEJ;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,gBAAA;AAAF;;AAGA;EACE;;;IAGE,0BAAA;EAAF;EAGA;IACE,uBAAA;IACA,sBAAA;EADF;AACF","sourcesContent":["@import './variables';\n\n// ── Page shell ─────────────────────────────────────────────────\n.prf-page {\n  min-height: calc(100vh - 80px);\n  background: #f0f4f8;\n  padding: 40px 20px 60px;\n}\n\n// ── 2-column layout ────────────────────────────────────────────\n.prf-layout {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  max-width: 1000px;\n  margin: 0 auto;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.prf-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.prf-main {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n// ── Card ───────────────────────────────────────────────────────\n.prf-card {\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  padding: 24px;\n\n  &--identity {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 8px;\n  }\n}\n\n// ── Avatar ─────────────────────────────────────────────────────\n.prf-avatar {\n  width: 92px;\n  height: 92px;\n  border-radius: 50%;\n  object-fit: cover;\n  display: block;\n  border: 3px solid $brand-color;\n  box-shadow: 0 8px 24px rgba(18, 183, 173, 0.22);\n  margin-bottom: 6px;\n}\n\n// ── Identity text ──────────────────────────────────────────────\n.prf-name {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 4px 0 0;\n  line-height: 1.25;\n}\n\n.prf-email {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  font-size: 0.8rem;\n  color: #94a3b8;\n  margin: 0 0 8px;\n}\n\n// ── Detail rows inside identity card ──────────────────────────\n.prf-detail-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 0;\n  border-bottom: 1px solid #f1f5f9;\n\n  &:last-of-type { border-bottom: none; }\n}\n\n.prf-detail-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.78rem;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.prf-detail-value {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #1e293b;\n  text-align: right;\n}\n\n.prf-empty {\n  color: #c0cfe0;\n  font-style: italic;\n  font-weight: 400;\n}\n\n// ── Inputs ─────────────────────────────────────────────────────\n.prf-input {\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  color: #0f172a;\n  width: 100%;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    border-color: $brand-color;\n    box-shadow: 0 0 0 3px rgba($brand-color, 0.12);\n  }\n\n  &--name {\n    text-align: center;\n    font-size: 1.1rem;\n    font-weight: 700;\n  }\n}\n\n// ── Buttons ────────────────────────────────────────────────────\n.prf-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 9px 18px;\n  transition: all 0.2s;\n  border: none;\n\n  &--primary {\n    background: $brand-color;\n    color: #fff;\n    &:hover:not(:disabled) { background: darken($brand-color, 8%); }\n    &:disabled { opacity: 0.6; cursor: not-allowed; }\n  }\n\n  &--outline {\n    background: transparent;\n    border: 1.5px solid $brand-color;\n    color: $brand-color;\n    &:hover { background: $brand-color; color: #fff; }\n  }\n\n  &--ghost {\n    background: transparent;\n    border: 1.5px solid #e2e8f0;\n    color: #64748b;\n    &:hover { border-color: #adb5bd; color: #333; }\n    &:disabled { opacity: 0.5; cursor: not-allowed; }\n  }\n\n  &--full { width: 100%; margin-top: 4px; }\n\n  &--sm { padding: 6px 14px; font-size: 0.8rem; }\n}\n\n.prf-edit-actions {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  margin-top: 4px;\n\n  .prf-btn { flex: 1; }\n}\n\n// ── Stats strip ────────────────────────────────────────────────\n.prf-stats {\n  display: flex;\n  align-items: stretch;\n  padding: 16px 20px;\n  gap: 0;\n}\n\n.prf-stat {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n\n  &__num {\n    font-size: 1.5rem;\n    font-weight: 800;\n    color: $brand-color;\n    line-height: 1;\n  }\n\n  &__lbl {\n    font-size: 0.7rem;\n    color: #94a3b8;\n    text-align: center;\n    line-height: 1.3;\n  }\n}\n\n.prf-stat-divider {\n  width: 1px;\n  background: #f1f5f9;\n  margin: 4px 0;\n}\n\n// ── Section titles ─────────────────────────────────────────────\n.prf-section-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.prf-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n// ── Profile completion ─────────────────────────────────────────\n.prf-completion {\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 14px;\n  }\n\n  &__sub {\n    font-size: 0.8rem;\n    color: #94a3b8;\n    margin: 3px 0 0;\n  }\n\n  &__pct {\n    font-size: 1.6rem;\n    font-weight: 800;\n    color: $brand-color;\n    line-height: 1;\n    flex-shrink: 0;\n  }\n}\n\n.prf-progress-track {\n  width: 100%;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 99px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.prf-progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, $brand-color, lighten($brand-color, 10%));\n  border-radius: 99px;\n  transition: width 0.6s ease;\n}\n\n.prf-checklist {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 0.85rem;\n    color: #94a3b8;\n\n    &--done {\n      color: #1e293b;\n      .prf-checklist__dot {\n        background: $brand-color;\n        box-shadow: 0 0 0 3px rgba($brand-color, 0.18);\n        &::after { content: '✓'; color: #fff; font-size: 0.55rem; font-weight: 800; }\n      }\n    }\n  }\n\n  &__dot {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 2px solid #e2e8f0;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n// ── Interview list ─────────────────────────────────────────────\n.prf-iv-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.prf-iv-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 0;\n  border-bottom: 1px solid #f1f5f9;\n\n  &:last-child { border-bottom: none; }\n\n  &__icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    background: #f0fffe;\n    color: $brand-color;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  &__body {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__job {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #1e293b;\n    margin: 0 0 2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__date {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    margin: 0;\n  }\n\n  &__right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    flex-shrink: 0;\n  }\n\n  &__score {\n    font-size: 0.78rem;\n    font-weight: 700;\n    color: #64748b;\n  }\n}\n\n// ── Badge ──────────────────────────────────────────────────────\n.prf-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 99px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n\n  &--strong  { background: #d1fae5; color: #065f46; }\n  &--average { background: #fef9c3; color: #854d0e; }\n  &--weak    { background: #fee2e2; color: #991b1b; }\n  &--pending { background: #dbeafe; color: #1e40af; }\n  &--done    { background: #f1f5f9; color: #475569; }\n}\n\n// ── Link button ────────────────────────────────────────────────\n.prf-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  background: none;\n  border: none;\n  color: $brand-color;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  transition: opacity 0.2s;\n\n  &:hover { opacity: 0.75; }\n\n  &--sm { font-size: 0.75rem; }\n}\n\n// ── Skeleton ───────────────────────────────────────────────────\n.prf-skeleton-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.prf-skeleton-row {\n  height: 52px;\n  border-radius: 10px;\n  background: linear-gradient(90deg, #f1f5f9 25%, #e8eef4 50%, #f1f5f9 75%);\n  background-size: 400% 100%;\n  animation: prf-shimmer 1.4s ease infinite;\n}\n\n@keyframes prf-shimmer {\n  0%   { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n// ── Empty state ────────────────────────────────────────────────\n.prf-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 32px 0;\n  color: #c0cfe0;\n\n  p { margin: 0; font-size: 0.88rem; }\n}\n\n// ── Spinner ────────────────────────────────────────────────────\n.prf-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: prf-spin 0.7s linear infinite;\n  display: inline-block;\n}\n\n@keyframes prf-spin { to { transform: rotate(360deg); } }\n\n// ── Toast ──────────────────────────────────────────────────────\n.prf-toast {\n  position: fixed;\n  top: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9999;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.12);\n  white-space: nowrap;\n  animation: prf-slide-in 0.3s ease;\n\n  &--success { background: #d1fae5; color: #065f46; border: 1px solid #a7f3d0; }\n  &--error   { background: #fee2e2; color: #991b1b; border: 1px solid #fca5a5; }\n}\n\n@keyframes prf-slide-in {\n  from { top: 8px; opacity: 0; }\n  to   { top: 24px; opacity: 1; }\n}\n\n\n.profile-page {\n  min-height: calc(100vh - 80px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 60px 16px 40px;\n  background: #f5f7fa;\n}\n\n.profile-card {\n  width: 100%;\n  max-width: 560px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 36px 24px 24px;\n    text-align: center;\n  }\n\n  &__name {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1a1a2e;\n    margin: 12px 0 4px;\n  }\n\n  &__email {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.875rem;\n    color: #6c757d;\n    margin-bottom: 16px;\n  }\n\n  &__info {\n    padding: 0 24px 24px;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    padding: 0 24px 24px;\n    justify-content: flex-end;\n\n    @media (max-width: 480px) {\n      flex-direction: column-reverse;\n    }\n  }\n}\n\n.profile-divider {\n  margin: 0 24px;\n  border-color: #f0f0f0;\n}\n\n.profile-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, $brand-color, darken($brand-color, 10%));\n  color: #fff;\n  font-size: 1.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.profile-info-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 0;\n  border-bottom: 1px solid #f5f5f5;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.profile-info-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.8125rem;\n  color: #6c757d;\n  width: 110px;\n  flex-shrink: 0;\n}\n\n.profile-info-value {\n  font-size: 0.9375rem;\n  color: #222;\n  font-weight: 500;\n}\n\n.profile-input {\n  flex: 1;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 0.9375rem;\n  outline: none;\n  transition: border-color 0.2s;\n  color: #1a1a2e;\n\n  &:focus {\n    border-color: $brand-color;\n    box-shadow: 0 0 0 3px rgba($brand-color, 0.12);\n  }\n\n  &--name {\n    text-align: center;\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin: 10px 0 4px;\n    max-width: 320px;\n    flex: none;\n    width: 100%;\n  }\n}\n\n.profile-btn-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 18px;\n  border: 1.5px solid $brand-color;\n  color: $brand-color;\n  background: transparent;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: $brand-color;\n    color: #fff;\n  }\n}\n\n.profile-btn-save {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 24px;\n  background: $brand-color;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover:not(:disabled) {\n    background: darken($brand-color, 8%);\n  }\n\n  &:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n  }\n\n  @media (max-width: 480px) {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.profile-btn-cancel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 18px;\n  background: transparent;\n  border: 1.5px solid #dee2e6;\n  color: #6c757d;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover:not(:disabled) {\n    border-color: #adb5bd;\n    color: #333;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  @media (max-width: 480px) {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.profile-last-updated {\n  text-align: center;\n  font-size: 0.75rem;\n  color: #adb5bd;\n  padding: 0 24px 20px;\n  margin: 0;\n}\n\n.profile-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: profile-spin 0.7s linear infinite;\n  display: inline-block;\n}\n\n@keyframes profile-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.profile-toast {\n  position: fixed;\n  top: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9999;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  animation: profile-slide-down 0.3s ease;\n  white-space: nowrap;\n\n  &--success {\n    background: #d1f2eb;\n    color: #1a7a5e;\n    border: 1px solid #a3e4d7;\n  }\n\n  &--error {\n    background: #fdecea;\n    color: #c0392b;\n    border: 1px solid #f5c6cb;\n  }\n}\n\n@keyframes profile-slide-down {\n  from {\n    top: 8px;\n    opacity: 0;\n  }\n  to {\n    top: 24px;\n    opacity: 1;\n  }\n}\n\n.prf-candidate {\n  display: grid;\n  gap: 18px;\n}\n\n.prf-candidate__subtitle,\n.prf-candidate__muted {\n  margin: 5px 0 0;\n  color: #6b7f92;\n  font-size: 13px;\n}\n\n.prf-candidate__loading,\n.prf-candidate__empty {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #5d7185;\n}\n\n.prf-candidate__notice {\n  padding: 11px 13px;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.prf-candidate__notice--success {\n  color: #08745f;\n  background: #e9f9f3;\n}\n\n.prf-candidate__notice--error {\n  color: #a63232;\n  background: #fff0f0;\n}\n\n.prf-candidate__summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.prf-candidate__summary-item {\n  min-width: 0;\n  padding: 12px;\n  border: 1px solid #e3ebf2;\n  border-radius: 8px;\n  background: #fbfdff;\n\n  span,\n  strong {\n    display: block;\n  }\n\n  span {\n    margin-bottom: 4px;\n    color: #718397;\n    font-size: 11px;\n    text-transform: uppercase;\n  }\n\n  strong {\n    color: #17324d;\n    font-size: 13px;\n    overflow-wrap: anywhere;\n  }\n}\n\n.prf-candidate__description {\n  span {\n    color: #718397;\n    font-size: 12px;\n  }\n\n  p {\n    margin: 6px 0 0;\n    color: #314b63;\n    line-height: 1.65;\n  }\n}\n\n.prf-candidate__form,\n.prf-candidate__subsection {\n  display: grid;\n  gap: 16px;\n}\n\n.prf-candidate__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.prf-candidate__form label {\n  display: grid;\n  gap: 6px;\n  min-width: 0;\n\n  > span {\n    color: #28445f;\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  input,\n  select,\n  textarea {\n    width: 100%;\n    min-width: 0;\n    border: 1px solid #d8e3ed;\n    border-radius: 8px;\n    padding: 10px 11px;\n    color: #17324d;\n    background: #fff;\n    outline: none;\n\n    &:focus {\n      border-color: #16aaa1;\n      box-shadow: 0 0 0 3px rgba(22, 170, 161, 0.12);\n    }\n\n    &[readonly] {\n      color: #6e8193;\n      background: #f3f6f9;\n    }\n  }\n}\n\n.prf-candidate__wide-field {\n  grid-column: 1 / -1;\n}\n\n.prf-candidate__subsection {\n  padding-top: 16px;\n  border-top: 1px solid #e6edf3;\n\n  h4 {\n    margin: 0;\n    color: #17324d;\n    font-size: 15px;\n  }\n}\n\n.prf-candidate__subsection-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.prf-candidate__history {\n  display: grid;\n  gap: 13px;\n  padding: 14px;\n  border: 1px solid #e0e8ef;\n  border-radius: 8px;\n  background: #fbfdff;\n}\n\n.prf-candidate__remove {\n  justify-self: start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: 0;\n  color: #b43b3b;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.prf-candidate__documents {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  padding-top: 16px;\n  border-top: 1px solid #e6edf3;\n\n  h4 {\n    margin: 0 0 10px;\n    color: #17324d;\n    font-size: 14px;\n  }\n\n  .image-uploader-container {\n    min-height: 190px;\n  }\n}\n\n.prf-candidate__actions {\n  justify-content: flex-end;\n  padding-top: 4px;\n}\n\n@media (max-width: 820px) {\n  .prf-candidate__summary,\n  .prf-candidate__grid,\n  .prf-candidate__documents {\n    grid-template-columns: 1fr;\n  }\n\n  .prf-candidate .prf-section-head {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n","$brand-color: #12b7ad !default;\n$brand2-color: #F7C154 !default;\n$bg-brand-color: #cce8e6 !default;\n$text-color: #31353bcf !default;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
